(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("speech2text", [], factory);
	else if(typeof exports === 'object')
		exports["speech2text"] = factory();
	else
		root["speech2text"] = factory();
})(window, function() {
return 